// Core
import { CSSProperties, ReactNode, Ref } from 'react';
// Packages
import { Layout as AntLayout } from 'antd';

interface IContentProps {
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
  ref?: Ref<HTMLElement>;
}

/**
 * Handling the overall layout of a page.
 *
 * @param className - Container className
 * @param style - To customize the styles
 * @param children - Some ReactNode
 * @param ref - The <main> element (React 19 passes `ref` as a prop)
 */

const Content = ({ className, style, children, ref }: IContentProps) => (
  <AntLayout.Content ref={ref} className={className} style={style}>
    {children}
  </AntLayout.Content>
);

export default Content;
